import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type BlockCardRequest } from '@shared/api';

interface BlockCardType {
  loading: boolean;
  error: string | null;
  success: boolean;
  block: (request: BlockCardRequest, id: string, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useBlockCardStore = create<BlockCardType>((set) => ({
  loading: false,
  error: null,
  success: false,

  block: ApiUtils.wrapperApi(async (request, id, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.blockCard(request, id, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), success: false, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  resetError: () => set({ error: null }),

  clear: () => set({ success: false, loading: false, error: null }),
}));
